const ROUTE_PARAM_VALUES = {
    LTE: 'lte',
    SIDEWALK: 'sidewalk',
    WIFI: 'wifi',
};

export default ROUTE_PARAM_VALUES;
